const SuppBarButton = ({
  containerStyle,
  iconStyle,
  textContent,
  iconContent,
  handleClick
}) => {
  return (
    <button
      className={`mx-2 h-14 w-auto p-3 flex items-center ${containerStyle}`}
      onClick={handleClick}
    >
      <span
        className={`support-icon-image text-2xl bg-transparent mr-2 ${iconStyle}`}
      >
        {iconContent}
      </span>
      {textContent}
    </button>
  );
};

export default SuppBarButton;
